import React, { Component } from "react";
import FriendsFollowersCardViewAllComponent from "./FriendsFollowersCardViewAllComponent";
import loadinggif from "../../../assets/images/loading.gif";
import NotFoundContainer from "../../../containers/NotFoundContainer";

class FriendsFollowersViewAllComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.invalidateFriendsProfileDetails();
    this.props.fetchFriendsProfileIfNeeded({
      profileId: this.props.match.params.id
    });

    const {
      fetchFriendsFollowersViewAllIfNeeded,
      invalidateAllFriendsFollowersViewAll
    } = this.props;
    invalidateAllFriendsFollowersViewAll();
    fetchFriendsFollowersViewAllIfNeeded({
      profileId: this.props.match.params.id,
      onlyId: false
    });
  }
  componentDidUpdate() {
    document.body.classList.remove("modal-open");
  }

  render() {
    const { friendsFollowersList, friendDetails } = this.props;

    if (friendsFollowersList.isFetching) {
      return (
        <div className="text-center">
          <div className="col-sm-12">
            <img src={loadinggif} alt="" />
          </div>
        </div>
      );
    }
    if (!(friendsFollowersList.items.length > 0)) {
      return <NotFoundContainer />;
    }

    if (
      friendsFollowersList &&
      friendDetails &&
      friendDetails.item &&
      friendsFollowersList.items
    ) {
      return (
        <section className="container-fluid my-tournament-wrapper">
          <div className="row">
            <div className="container">
              <div className="padder-main">
                <div className="row d-flex align-items-center mb-30 ">
                  <div className="col-8 d-flex justify-content-start">
                    <h2 className="bold">
                      {friendDetails.item.name}'s Followers
                    </h2>
                  </div>
                </div>

                <div className="row card-wrapper d-flex justify-content-center justify-content-sm-start">
                  {this.props.friendsFollowersList.items.length > 0
                    ? this.props.friendsFollowersList.items.map(
                        (follower, i) => (
                          <div className="col-auto mb-4" key={i}>
                            <FriendsFollowersCardViewAllComponent
                              {...follower}
                              key={i}
                            />
                          </div>
                        )
                      )
                    : ""}
                </div>
                {/* <div className="row mb-30 text-center">
                  <div className="col-sm-12">
                    {this.props.friendsFollowersList.items.length > 0 ? (
                      !this.props.friendsFollowersList.isLastPage ? (
                        <button
                          onClick={() => {
                            this.props.invalidateAllFriendsTournamentsViewAll();
                            this.props.fetchFriendsFollowersViewAllIfNeeded({
                              profileId: this.props.match.params.id,
                              page: page
                            });
                          }}
                          className="btn btn-pink dark btn-xs"
                        >
                          Load More
                        </button>
                      ) : this.props.friendsFollowersList.isFetching ? (
                        <img src={loadinggif} alt="" />
                      ) : (
                        ""
                      )
                    ) : this.props.friendsFollowersList.isFetching ? (
                      <img className="text-center" src={loadinggif} alt="" />
                    ) : (
                      <span>No Followers Found</span>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return <></>;
    }
  }
}

export default FriendsFollowersViewAllComponent;
